<template>
  <div class="login-wrapper">
    <b-container fluid>
      <b-row class="justify-content-center align-items-center min-vh-100">
        <b-col cols="12" md="6" lg="5" xl="4">
          <div class="auth-card">
            <h2 class="section-title mb-4">{{ $t("globals.sign_in") }}</h2>

            <div class="form-group mb-4">
              <label class="form-label">{{ $t("globals.email") }}</label>
              <b-input
                v-model="email"
                type="text"
                class="form-input"
              />
            </div>

            <div class="form-group mb-4">
              <label class="form-label">{{ $t("globals.password") }}</label>
              <b-input
                v-model="pass"
                @keyup.enter="callLogin"
                type="password"
                class="form-input"
              />
            </div>

            <b-btn
              class="auth-button w-100 mb-3"
              @click="callLogin"
              :disabled="loginDisabled"
            >
              {{ $t("globals.login") }}
            </b-btn>

            <p v-if="getLoginInfo" class="text-center text-secondary mt-3">{{ getLoginInfo }}</p>
          </div>
        </b-col>
      </b-row>
    </b-container>
    <ulu-loading />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  components: {
    "ulu-loading": () => import("@/components/Loading")
  },
  data() {
    return {
      email: "",
      pass: ""
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    callLogin() {
      if (!this.loginDisabled) {
        this.login({ email: this.email, password: this.pass });
      }
    }
  },
  computed: {
    ...mapGetters("auth", ["getLoginInfo"]),
    loginDisabled() {
      // eslint-disable-next-line
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return !(this.pass.length !== 0 && re.test(String(this.email)));
    }
  }
};
</script>

<style scoped>
.login-wrapper {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.auth-card {
  background: white;
  border-radius: 8px;
  padding: 3rem 2.5rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

.section-title {
  font-size: 1.75rem;
  font-weight: 400;
  color: #2c3e50;
  margin-bottom: 2rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid #e0e0e0;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-label {
  display: block;
  font-size: 0.95rem;
  color: #2c3e50;
  margin-bottom: 0.5rem;
  font-weight: 400;
}

.form-input {
  width: 100%;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  border: 1px solid #d0d0d0;
  border-radius: 4px;
  transition: border-color 0.2s;
}

.form-input:focus {
  border-color: #17a2b8;
  outline: none;
  box-shadow: 0 0 0 3px rgba(23, 162, 184, 0.1);
}

.auth-button {
  background-color: #17a2b8;
  border: none;
  color: white;
  font-size: 1rem;
  font-weight: 500;
  padding: 0.875rem 1.5rem;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.auth-button:hover:not(:disabled) {
  background-color: #138496;
}

.auth-button:disabled {
  background-color: #a0a0a0;
  cursor: not-allowed;
}
</style>
